import ProductTemplateLubi from "../templates/product-template-lubi";
import { LubiSmps } from '../data/products'

function ProductLubiSmps() {
    return (
        <>
            <ProductTemplateLubi data = {LubiSmps}/>
        </>
    )
}

export default ProductLubiSmps;